import React from 'react';
import Chart_component from './Chart_component';

import { connect } from 'react-redux';




function Timeline_item_chart(props) {


    let queue_label_dic = {}; console.log(props.queues, 'QUEUES');


    if (props.queues != undefined) { for (let q_key in props.queues) { let q = props.queues[q_key]; if (q.id != 'all') { queue_label_dic[q.id] = q.name; } } }



    return (<Chart_component
        chart_type_labels={{ 0: 'Emails', 1: 'Phone calls', 2:'Notes', 3: 'Meetings', 5: 'Messages', 4: 'Tasks due' }}
        chart_sub_type_labels={props.timeline_item_sub_types}
        {...props}
    />);
}




export default connect(ss, dd)(Timeline_item_chart);


function ss(state) {
    return {
        refresh: state.analytics.refresh,
        timeline_item_data: state.analytics.data,
        queues: state.lists.queue_data,
        analytics_settings: state.analytics.settings,
        message_types: state.account.message_types,
        refresh_message_types: state.account.refresh
    }
}

function dd(dispatch) {
    return {
        getChartAnalyticsData:(url)=>{dispatch({type:'REQUEST_INDEX_CHART_DATA', url:url})},
        getTimelineItemsData: (user_workspace_id, start_date, end_date, type, sub_type) => { dispatch({ type: 'REQUEST_INDEX_TIMELINE_ITEMS', user_workspace_id: user_workspace_id, start_date: start_date, end_date: end_date, d_type: type, sub_type: sub_type }); },
        index_queues: () => { dispatch({ type: 'REQUEST_QUEUE_INDEX' }) },
        get_analytics_data: () => { dispatch({ type: 'REQUEST_GET_ANALYTICS_SETTINGS' }) },
        createUpdateChart: (val) => { dispatch({ type: 'REQUEST_CREATE_UPDATE_ANALYTICS_CHART', val: val }) },
        getMessageTypes: () => { dispatch({ type: 'REQUEST_INDEX_MESSAGE_TYPES' }) },
        deleteChart: (id) => { dispatch({ type: 'REQUEST_DELETE_ANALYTICS_CHART', id: id }) }
    }
}